import AccountPage from 'pages/account/Account';
import DepositPage from 'pages/deposit/DepositPage';
import HelpPage from 'pages/help/HelpPage';
import HomePage from 'pages/homepage/HomePage';
import LobbyPage from 'pages/lobby/lobbyPage';
import LotteryPage from 'pages/lottery/LotteryPage';
import LuckyWin from 'pages/lucky-win/lucky-win';
import PromotionDetail from 'pages/promo-detail/PromotionDetail';
import PromotionPage from 'pages/promotion/PromotionPage';
import Register from 'pages/register/Register';
import Slots from 'pages/slot/Slots';

interface MainRoutes {
    path: string;
    page: React.FC;
    isPrivate: boolean;
}

//public routes
const mainRoutes: MainRoutes[] = [
    {
        path: '/',
        page: HomePage,
        isPrivate: false,
    },
    {
        path: '/deposit',
        page: DepositPage,
        isPrivate: true,
    },
    {
        path: '/promotion',
        page: PromotionPage,
        isPrivate: false,
    },
    {
        path: '/promotion/:id',
        page: PromotionDetail,
        isPrivate: false,
    },
    {
        path: '/account',
        page: AccountPage,
        isPrivate: true,
    },
    {
        path: '/lottery',
        page: LotteryPage,
        isPrivate: true,
    },
    {
        path: '/lobby',
        page: LobbyPage,
        isPrivate: false,
    },
    {
        path: '/slots',
        page: Slots,
        isPrivate: false,
    },
    {
        path: '/help',
        page: HelpPage,
        isPrivate: false,
    },
    {
        path: '/lucky-win',
        page: LuckyWin,
        isPrivate: true,
    },
];

export { mainRoutes };
